// import { toast } from "../components";

import parseUrl from "parse-url";
import localStorageKey from "../enumerations/localStorageKey";

export const copyText = (text, successMessageContent) => {
  if (!text) return;
  // navigator.clipboard.writeText(text);
  const selectGroup = document.getElementById("copy-group");
  let tempArea = document.createElement("textarea");
  selectGroup?.appendChild(tempArea);
  tempArea.innerText = text;
  tempArea.select();
  document.execCommand("Copy");
  selectGroup?.removeChild(tempArea);
  // toast({ content: successMessageContent, type: "success" });
};

export const getCurrency = () => {
  const storageCurrency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);
  const queryStringObject = parseUrl(window.location.href).query;
  const queryCurrency = queryStringObject.currency;
  return storageCurrency || queryCurrency || process.env.REACT_APP_DEFAULT_CURRENCY;
};

export const getUserCurrency = (toLocaleLowerCase = false) => {
  const currency =
    window.localStorage.getItem(localStorageKey.USER_CURRENCY) ??
    process.env.REACT_APP_DEFAULT_CURRENCY;
  return toLocaleLowerCase ? currency?.toLocaleLowerCase() : currency;
};

export const getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const envType = {
  NUMBER: "number",
  BOOLEAN: "boolean",
  ARRAY: "array",
  STRING: "string",
  OBJECT: "object",
};

export const envChangeType = (target, type = envType.STRING) => {
  switch (type) {
    case envType.NUMBER:
    case envType.BOOLEAN:
      return JSON.parse(process.env[target] || "");
    case envType.OBJECT:
      return JSON.parse(process.env[target] || "");
    case envType.ARRAY:
      return process.env[target]?.split(",");
    default:
      return process.env[target];
  }
};
